var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('div',{staticClass:"content-top-line content-top-line--with-bottom-line"},[_c('div',{staticClass:"content-tabs content-tabs--empty"}),_c('div',{staticClass:"content-top-line-wrap"})])])
}]

export { render, staticRenderFns }